import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useSiteData, scrollToId } from "@/lib/api";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Services } from "@/components/site/Services";
import { Packs } from "@/components/site/Packs";
import { Portfolio } from "@/components/site/Portfolio";
import { About } from "@/components/site/About";
import { Footer } from "@/components/site/Footer";
import { CheckoutDialog } from "@/components/site/CheckoutDialog";
import { WhatsAppFloat } from "@/components/site/WhatsAppFloat";

export default function Home() {
  const { services, packs, portfolio, settings, loaded } = useSiteData();
  const [buying, setBuying] = useState(null);
  const { hash } = useLocation();
  useEffect(() => {
    if (!loaded || !hash) return undefined;
    const t = setTimeout(() => scrollToId(hash.slice(1)), 300);
    return () => clearTimeout(t);
  }, [loaded, hash]);
  return (
    <div className="bg-[#041214]" data-testid="home-page">
      <SmoothScroll />
      <Nav settings={settings} />
      <Hero />
      <Marquee />
      <Services services={services} onBuy={setBuying} />
      <Packs packs={packs} onBuy={setBuying} />
      <Portfolio items={portfolio} />
      <About settings={settings} />
      <Footer settings={settings} />
      <CheckoutDialog key={buying?.id || "none"} item={buying} kind={buying?.version !== undefined ? "pack" : "service"} settings={settings} onClose={() => setBuying(null)} />
      <WhatsAppFloat settings={settings} />
    </div>
  );
}
